export default __webpack_public_path__ + "static/media/netbanking-otm-icon.81d69e01.svg";